// extracted by mini-css-extract-plugin
module.exports = {"root":"CallToAction_root__36RVE","title":"CallToAction_title__7maYC","button":"CallToAction_button__huyUH"};